const DEFAULT_USER = {
  id: '',
  isAuth: false,
  profile: {
    email: '',
    firstName: '',
    lastName: '',
    companyName: '',
    companyLogo: '',
    avatar: ''
  }
};

const moduleUser = {
  namespaced: true,
  state: () => ({
    user: DEFAULT_USER
  }),
  getters: {
    userId(state) {
      return state.user.id ?? DEFAULT_USER.id;
    },
    isAuth(state) {
      return state.user.isAuth ?? DEFAULT_USER.isAuth;
    },
    profile(state) {
      return state.user.profile ?? DEFAULT_USER.profile;
    }
  },
  mutations: {
    logIn(state, data) {
      state.user = {
        id: data.id,
        isAuth: true,
        profile: formatProfile(data)
      };
    },
    updateProfile(state, data) {
      state.user = {
        id: data.id,
        isAuth: true,
        profile: formatProfile(data)
      };
    },
    logOut(state) {
      state.user = DEFAULT_USER;
    }
  },
  actions: {
    async logInUser({ commit }, payload) {
      commit('logIn', payload);
    },
    async updateUserProfile({ commit }, payload) {
      commit('updateProfile', payload);
    },
    async logOutUser({ commit }) {
      commit('logOut');
    }
  }
};

function formatProfile(profile) {
  const result = {
    email: profile?.email ?? '',
    firstName: profile?.firstName ?? '',
    lastName: profile?.lastName ?? '',
    companyName: profile?.companyName ?? '',
    companyLogo: profile?.companyLogo ?? '',
    avatar: profile?.avatar ?? ''
  };

  return result;
}

export default moduleUser;
